import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Revelation } from './components/Revelation';
import { Benefits } from './components/Benefits';
import { BookDescription } from './components/BookDescription';
import { Testimonials } from './components/Testimonials';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-matrix-black text-matrix-white font-inter selection:bg-matrix-green selection:text-matrix-black" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Revelation data-id="element-3" />
      <Benefits data-id="element-4" />
      <BookDescription data-id="element-5" />
      <Testimonials data-id="element-6" />
      <CTA data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}